import React from "react";
import { string, number, any, array, func, shape, bool } from "prop-types";
import { Link } from "react-router-dom";
import moment from "moment";
import * as style from "./styles.module.scss";
import LabeledValue from "../LabeledValue";
import { Button } from "../../common";

const parseHours = (hours) => hours.substr(0, 5);

const msToHours = (differenceInMs) => differenceInMs / 1000 / 60 / 60;

const timeDiff = (timeStart, timeEnd) => {
  const startDate = moment(`1970-01-01 ${timeStart}`);
  const endDate = moment(`1970-01-01 ${timeEnd}`);
  const differenceInMs = endDate - startDate;
  const differenceInHours = msToHours(differenceInMs);
  return Math.round(differenceInHours * 100) / 100;
};

const Booking = ({
  companyName,
  jobTitle,
  shiftType,
  location = undefined,
  startDate,
  endDate,
  vacancyDurationValue,
  vacancyDurationUnitCode,
  startTime,
  endTime,
  vacancyCreated,
  yourHrgoConsultant,
  hrgoContactDetails,
  rates,
  parseDate,
  vacancyRef,
  isPast,
}) => {
  const parseVacancyUnitCode = (unitCode) => {
    switch (unitCode) {
      case "D":
        return "Days";
      case "M":
        return "Months";
      case "W":
        return "Weeks";
      default:
        return "Value";
    }
  };
  const parseVacancyDuration = (duration, unitCode) =>
    duration ? `${duration} ${parseVacancyUnitCode(unitCode)}` : "";
  const parseEndDate = (date) =>
    date !== "" ? parseDate(date) : "No end date";
  const parseVacancyDates = (start, end, duration) =>
    `${parseDate(start)} - ${parseEndDate(end)}\n${parseVacancyDuration(
      duration,
      vacancyDurationUnitCode
    )}`;
  return (
    <div className={`${style.booking__wrapper} p-sm-1`}>
      <span className={`d-flex flex-column ${style.booking__section}`}>
        <span className={`${style.booking__titleWrapper} p-1 p-sm-0`}>
          <h4 className={`mb-0 ${style.booking__jobTitle}`}>{jobTitle}</h4>
          <p className={`mb-0 font-weight-bold ${style.booking__companyName}`}>
            {companyName}
          </p>
        </span>
        <p
          className={`py-sm-1 font-weight-bold ${style.booking__shiftType} px-1 px-sm-0`}
        >
          {shiftType}
        </p>
        {location && (
          <LabeledValue
            className="px-1 px-sm-0"
            header="address"
          >{`${location.line1}\n${location.postTown}\n${location.zipCode}`}</LabeledValue>
        )}
      </span>

      <span
        className={`d-flex flex-column px-1 px-sm-0 ${style.booking__section}`}
      >
        <LabeledValue
          className={`mb-1 ${style.booking__firstSubsection}`}
          header="vacancy duration"
        >
          {parseVacancyDates(startDate, endDate, vacancyDurationValue)}
        </LabeledValue>
        <div className="d-flex">
          <LabeledValue header="start time">
            {parseHours(startTime)}
          </LabeledValue>
          <LabeledValue className="px-2" header="end time">
            {parseHours(endTime)}
          </LabeledValue>
          <LabeledValue header="hours">
            {timeDiff(startTime, endTime).toString()}
          </LabeledValue>
        </div>
        <LabeledValue header="vacancy created" className="mt-1">
          {parseDate(vacancyCreated)}
        </LabeledValue>
      </span>

      <span
        className={`d-flex flex-column px-1 px-sm-0 ${style.booking__section}`}
      >
        <LabeledValue
          className={`mb-1 ${style.booking__firstSubsection}`}
          header="your HRGO consultant"
        >
          {yourHrgoConsultant}
        </LabeledValue>
        <LabeledValue header="HRGO contact details">
          {hrgoContactDetails}
        </LabeledValue>
      </span>

      <span
        className={`d-flex flex-column ${style.booking__rates} align-items-end px-sm-1 px-sm-0 ${style.booking__section}`}
      >
        <LabeledValue header="hourly rate" className="pr-1" />
        {rates &&
          rates.map((_rateElement) => (
            <div
              className={`d-flex justify-content-between align-items-center w-100 ${style.booking__rate}`}
              key={_rateElement.name}
            >
              <p className="pl-1">{_rateElement.name}</p>
              <p className="pr-1">{_rateElement.amount}</p>
            </div>
          ))}
        <Link
          to={`/profile/edit/Bookings/${vacancyRef}${isPast ? "/past" : ""}`}
        >
          <Button
            classes={`btn btn-primary btn-block mb-2 w-100 ${style.booking__viewSchedule}`}
          >
            <b>View schedule</b>
          </Button>
        </Link>
      </span>
    </div>
  );
};

Booking.propTypes = {
  companyName: string,
  jobTitle: string,
  shiftType: string,
  location: shape({
    line1: string,
    line2: string,
    formattedAddress: string,
    postTown: string,
    zipCode: string,
  }),
  startDate: any,
  endDate: any,
  vacancyDurationValue: number,
  startTime: any,
  endTime: any,
  hours: number,
  vacancyCreated: any,
  yourHrgoConsultant: string,
  hrgoContactDetails: string,
  rates: array,
  parseDate: func,
  vacancyRef: number,
  isPast: bool,
  vacancyDurationUnitCode: string,
};

export default Booking;
